import React, { useState, useEffect } from "react";
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";

import subscriptionsApi from "../../hooks/GET/subscriptions";
import { formatLocalDate, formatLocalTime } from "../../utils/dateTime";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function SubscriptionDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // props value
  const { open, handleClose } = props;

  // subscription history logic start
  const [subscriptionHistory, setSubscriptionHistory] = useState([]);

  useEffect(() => {
    subscriptionsApi()
      .then((data) => {
        setSubscriptionHistory(data);
      })
      .catch((error) => console.log(error));
  }, []);
  // subscription history logic end

  // status color
  const statusColor = (status) => {
    if (status === "active") return "info.main";
    else if (status === "completed") return "success.main";
    else if (status === "cancelled") return "warning.main";
    else return "";
  };

  return (
    <Dialog
      open={open}
      scroll="paper"
      fullScreen={fullScreen}
      fullWidth
      maxWidth="md"
      TransitionComponent={Transition}
    >
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>Subscription History</Grid>
          <Grid item>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers sx={{ minHeight: "50vh" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Plan</TableCell>
                <TableCell align="center">Start date {"&"} time</TableCell>
                <TableCell align="center">End date {"&"} time</TableCell>
                <TableCell align="center">Amount</TableCell>
                <TableCell align="center">Period</TableCell>
                <TableCell align="center">Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {subscriptionHistory.map((fieldValue, idx) => (
                <TableRow key={idx} hover>
                  <TableCell>{fieldValue.planName}</TableCell>
                  <TableCell align="center">
                    <Typography>
                      {formatLocalDate(fieldValue.startDate)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {formatLocalTime(fieldValue.startDate)}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography>
                      {formatLocalDate(fieldValue.endDate)}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {formatLocalTime(fieldValue.endDate)}
                    </Typography>
                  </TableCell>
                  <TableCell align="center" sx={{ textTransform: "uppercase" }}>
                    {fieldValue.planPrice} {fieldValue.planCurrecyIsoCode}
                  </TableCell>
                  <TableCell align="center">
                    {fieldValue.planBillingInterval} months
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      textTransform: "capitalize",
                      color: statusColor(fieldValue.status),
                    }}
                  >
                    {fieldValue.status}
                  </TableCell>
                </TableRow>
              ))}
              {subscriptionHistory.length === 0 && (
                <TableRow style={{ height: 53 * 5 }}>
                  <TableCell align="center" colSpan={5}>
                    No subscription history available to display
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
}
